export default {
  methods: {
    _getProductImages: function () {
      var self = this
      const url = '/imagedesk/image/all'

      let data = {
        id_photodesk_session: self.selectedProduct.id_photodesk_session,
        id_product: self.selectedProduct.id_product
      }
      self.loadingRail = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.images = response.data.images
          self._getFinalSequence()
          self.loadingRail = false
        })
        .catch(function (error) {
          self.loadingRail = false
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
        })
    },
    _getFinalSequence: function () {
      var self = this
      const url = '/imagedesk/image/final'
      let data = {
        id_product: self.selectedProduct.id_product
      }

      self.loadingImages = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.finalImages = response.data.final_images
          self.loadingImages = false
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data.message,
            show: true
          })
          self.loadingImages = false
        })
    },
    getProduct: function (lock_desk=null) {
      var self = this
      const url = '/productdesk/product/view'

      let data = {
        id_product: self.selectedProduct.id_product
      }

      if(lock_desk) {
        data['lock_desk'] = lock_desk
      }


      self.loadingProduct = true
      self.loadingImages = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProduct = response.data
          self._getProductImages()
          self.loadingProduct = false
          self.waitingforAction = false
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
          self.loadingProduct = false
          self.waitingForAction = false
        })
    },
    updateFinalSequence: function () {
      var self = this
      const url = '/imagedesk/image/update/sequence'
      let data = {
        order: self.$store.getters.updateSequenceSet,
        id_product: self.selectedProduct.id_product
      }
      self.resequencingImages = 'pending'
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateSequenceUpdateRequired', false)
          self._getFinalSequence()
          self.resequencingImages = 'done'
          setTimeout(function () {
            self.resequencingImages = ''
          }, 2000)
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
        })
    }
  },
  computed: {
    sequenceUpdateRequired () {
      return this.$store.getters.sequenceUpdateRequired
    }
  },
  watch: {
    finalImages () {
      var list = this.finalImages.filter(function (el) {
        return el.id_image !== null
      })
      this.allocatedImages = list
    }
  }
}
